import { CVirtualScroller } from './CVirtualScroller.js';

const CVirtualScrollerPlugin = {
    install: (app) => {
        app.component(CVirtualScroller.name, CVirtualScroller);
    },
};

export { CVirtualScroller, CVirtualScrollerPlugin };
//# sourceMappingURL=index.js.map
